import Post from "../Post";
import getToken from "../token";

export default function getTimeNotif() {
  return Post("doctor/getTimeRemembered", {
    token: getToken(),
  });
}
